import React, { useState } from 'react';
import EnterOTP from './EnterOTP';
const ForgetPassword = ({ closeModal }) => {
  const clickHandler = () => {
    closeModal(false);
  };

  const [openOTP, setOpenOTP] = useState(false);

  const enterotpClickHandler = () => {
    setOpenOTP(!openOTP);
  };
  return (
    <div className='forgotpasswordModal'>
      <div id='ForgotPassword' className=''>
        <div className='m-5' style={{ width: '110%' }}>
          <div className='d-flex justify-content-end' onClick={clickHandler}>
            <button
              type='button'
              class='btn-close shadow-none'
              aria-label='Close'
            ></button>
          </div>
          <div className='d-block text-center'>
            <img
              src='/assests/logo2.png'
              alt='KIBI Sport'
              className='fluid-img'
            />
          </div>
          <div className='my-5 py-3'>
            <h1 className='mt-4 modalHeader d-flex justify-content-center'>
              Forgot Password
            </h1>
            <div className='text-center pt-5 mt-0'>
              <input
                type='text'
                name='name'
                placeholder='Enter Your Email Address '
                className='input-group p-3 rounded border border-secondary'
              />
              <br />

              {/* <input
            type='email'
            name='email'
            value={email}
            onChange={OnChange}
            placeholder='Email Address'
            className='input-group p-3 rounded border border-secondary'
          />
          <br />
          <input
            type='number'
            name='phone'
            value={phone}
            onChange={OnChange}
            placeholder='Phone Number'
            className='input-group p-3 rounded border border-secondary'
          />
          <br /> */}
              <div className='pt-3'>
                <button
                  onClick={enterotpClickHandler}
                  className='loginBtn p-3 rounded'
                >
                  Reset Password
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openOTP && <EnterOTP closeModal={setOpenOTP} />}
    </div>
  );
};

export default ForgetPassword;
